
import './App.css';
import Headerr from './components/Header';
import About from './components/About';
import Promotions from './components/Promotions';
import Menu from './components/Menu';
import Reservation from './components/Reservation';
import Footer from './components/Footer';
import ReactDOM from 'react-dom'

function App() {
  return (
    <div className="App">
      <Headerr/>
      <About/>
      {/* <Reservation/> */}
      <Promotions/>
      <Menu/>
      
      <Footer/>

    </div>
  );
}

export default App;
